import API from '@/api'

export default {
  namespaced: true,
  state: {
    stages: [],
    gdd:[
      // basalCropTemp: 0,
    ],
    temp: 0,
    loading: true,
  },
  mutations: {

    saveCropStages(state, data) {
      state.stages = data;
    },
    saveGdd(state, data) {
      state.gdd = data;
      // console.log(data);
    },
    saveLoading(state, bool) {
      state.loading = bool;
    },
    saveTemp(state, data) {
      state.temp = data;
    },

  },
  actions: {

    loadCropStages({rootGetters, commit}) {
      let yieldGoalId = rootGetters['program/data'].cropYieldGoalId;
      return API.crop.getCropStages(yieldGoalId).then(res => {
        commit('saveCropStages', res.data.data);
      });
    },

    loadGdd({commit, rootGetters, dispatch, state}, programId) {
      commit('saveLoading', true)
      return API.program.getGdd(programId)
      .then(res => {
        commit('saveGdd', res.data.data[0].data);
        commit('saveLoading', false);
        commit('saveTemp', res.data.data[0].basalCropTemp);
      })
      .catch(err => {
        dispatch('loadCropStages')
        commit('saveGdd', rootGetters[`program/gdd/stages`]);
        commit('saveTemp', 1);
        // commit('saveTemp', rootGetters[`program/gdd/stages`].map(el => {
        //   return {
        //     stageTemp: 0,
        //   }
        // }));
        commit('saveLoading', false);
      })
    },

  },
  getters: {
    stages(state) {
      // let stages = state.stages.map((el) => {
      //   return {
      //     id: el.id,
      //     name: el.name,
      //     duration: el.data.find(x => x.key == 'duration').value,
      //     order: el.order,
      //     gdd: el.gdd ? el.gdd : 0,
      //
      //
      //   }
      // });
      // return stages;
      return state.stages;
    },
    gdd(state) {
      return state.gdd;
    },
    temp(state) {
      return state.temp;
    },
    loading(state) {
      return state.loading;
    },

  }
};
